import React from "react";
import { Badge } from "@/components/ui/badge";
import { ArrowLink } from "./ArrowLink";

interface NavSubColumnItem {
  title: string;
  href: string;
  description?: string;
  badge?: string;
}

interface NavSubColumnProps {
  subtitle?: string;
  items: NavSubColumnItem[];
  cta?: {
    text: string;
    href: string;
  };
}

export const NavSubColumn = ({ subtitle, items, cta }: NavSubColumnProps) => (
  <div className="flex min-w-[240px]">
    <div className="flex flex-col flex-1">
      {subtitle && (
        <h3 className="text-lg-medium text-primary m-0 px-xl py-md">
          {subtitle}
        </h3>
      )}
      <ul className="list-none p-0 m-0 pt-md flex flex-col gap-xs">
        {items.map(({ title, href, description, badge }) => (
          <li key={href}>
            <a
              href={href}
              className="block min-[1280px]:flex min-[1280px]:items-baseline py-lg px-xl no-underline hover:no-underline hover:bg-bg-quaternary rounded-md transition-colors"
            >
              <span className="inline-flex items-center gap-md">
                <span className="text-sm-medium text-tertiary">{title}</span>
                {badge && (
                  <Badge variant="brand" size="sm">
                    {badge}
                  </Badge>
                )}
              </span>
              {description && (
                <>
                  <span className="[display:none] min-[1280px]:inline text-sm-regular text-quaternary mx-md">
                    —
                  </span>
                  <span className="block min-[1280px]:inline text-sm-regular text-quaternary mt-xs min-[1280px]:mt-0">
                    {description}
                  </span>
                </>
              )}
            </a>
          </li>
        ))}
      </ul>
      <div className="flex-1 min-h-4xl" />
      {cta && (
        <div className="px-xl py-md">
          <ArrowLink href={cta.href}>{cta.text}</ArrowLink>
        </div>
      )}
    </div>
  </div>
);
